import React from "react";

import { Heading } from "@busbud/horizon";

import type { HeadingProps } from "./types";

export const Heading2: React.FC<HeadingProps> = ({ id, children }) => {
  return (
    <Heading
      id={id}
      className="mb-300"
      as="h2"
      size={{ initial: "md", sm: "lg", xl: "xl" }}
    >
      {children}
    </Heading>
  );
};
